'use client';

import { usePathname, useRouter } from 'next/navigation';
import useStore from '../app/[locale]/admin/store';
import { HiUserCircle } from 'react-icons/hi2';
import DropdownMenu from './Menu/DropdownMenu';
import Image from 'next/image';
import React from 'react';
import ToastMessage from '@/components/ui/ToastMessage';
import { getDictionaryAction } from '@/app/api/products/actions';
import { createClient } from '@/app/utils/supabase/client';

interface SignOutProps {
    locale: string;
}

const SignOut = (props: SignOutProps) => {
    const { locale } = props;
    const router = useRouter();
    const { editing } = useStore();
    const [translation, setTranslation] = React.useState<
        | {
              [key: string]: string;
          }
        | undefined
    >(undefined);

    React.useEffect(() => {
        async function fetchData() {
            setTranslation(await getDictionaryAction(locale, 'signout'));
        }
        fetchData();
    }, [locale]);

    const supabase = createClient();
    const menuItems = [
        {
            name: 'profile',
            title: translation?.profile,
            href: '/admin/profile',
        },
        {
            name: 'logout',
            title: translation?.logout,
            href: '#',
            fnct: handleSignOut,
        },
    ];
    const pathname = usePathname();

    const slug = pathname.startsWith(`/${locale}/`)
        ? pathname.substring(3)
        : pathname;

    const notify = React.useCallback((type: string, message: string) => {
        ToastMessage({ type, message });
    }, []);

    const flagItems = [
        {
            name: 'fr',
            title: 'Français',
            image: '/assets/flags/fr.png',
            fnct: () =>
                editing
                    ? notify('error', translation.whenEditing)
                    : router.push(`/fr/${slug}`),
        },
        {
            name: 'en',
            title: 'English',
            image: '/assets/flags/en.png',
            fnct: () =>
                editing
                    ? notify('error', translation.whenEditing)
                    : router.push(`/en/${slug}`),
        },
    ];

    async function handleSignOut() {
        const { error } = await supabase.auth.signOut();

        if (error) {
            // eslint-disable-next-line no-console
            console.error('ERROR signing out:', error);
        }
        router.push(`/${locale}/auth`);
    }

    if (translation && pathname.includes('/admin')) {
        return (
            <div className="flex items-center space-x-4 md:order-2 ml-6">
                {process.env.NEXT_PUBLIC_LOCALES.split(',').length > 1 && (
                    <DropdownMenu menuItems={flagItems}>
                        <div className="w-8 h-8">
                            <Image
                                alt={translation.languageSelector}
                                className="rounded-full"
                                fill
                                sizes="45px"
                                src={`/assets/flags/${locale}.png`}
                                style={{
                                    objectFit: 'contain',
                                }}
                            />
                        </div>
                    </DropdownMenu>
                )}
                <DropdownMenu menuItems={menuItems}>
                    <div className="flex mt-2">
                        <HiUserCircle className="h-10 w-10 fill-primary cursor-pointer" />
                    </div>
                </DropdownMenu>
            </div>
        );
    }
};

export default SignOut;
